import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 1
export const listName = 'sl.website.banner'
export const listStorage = tableColumnsCache(listName, [
    {label: 'ID', name: 'id', active: true, sortable: true, ordering: 1},
    {label: 'Seção', name: 'secao', active: true, sortable: true, ordering: 2},
    {label: 'Tipo', name: 'type', active: true, sortable: true, ordering: 2},
    {label: 'Banner', name: 'image', active: true, sortable: true, ordering: 2},
    {label: 'Resolução', name: 'resolution', active: true, sortable: true, ordering: 2},
    {label: 'Descrição', name: 'title', active: true, sortable: true, ordering: 2},
    {label: 'Posição', name: 'position', active: true, sortable: true, ordering: 2},
    {label: 'Exibição', name: 'exibicao', active: true, sortable: true, ordering: 2},
    {label: 'Ativo', name: 'status', active: true, sortable: true, ordering: 3},
], listVersion)
